import Vue from 'vue'

Vue.component('checkbox', {
  props: {
    name: String,
    label: String,
    value: String,
    modifier: {
      type: String,
      default: 'default'
    },
    checkedString: String,
    checkedBool: Boolean,
    required: Boolean
  },
  data () {
    const data = {
      isValid: true,
      inputValue: false,
      isChecked: false,
      publicValue: this.value || true
    }
    if (this.checkedString || this.checkedBool) {
      data.isChecked = true
    }
    return data
  },
  watch: {
    checked () {
      this.isChecked = this.checked
    },
    checkedBool (value) {
      this.isChecked = value
    }
  },
  methods: {
    validateInput () {
      this.isValid = (
        !this.required ||
        (this.required && this.isChecked)
      )
      return this.isValid
    },
    onChange () {
      this.isChecked = !this.isChecked
      if (this.isChecked) {
        this.inputValue = this.publicValue
      } else {
        this.inputValue = false
      }
      this.$emit('change', {
        name: this.name,
        value: this.inputValue
      })
    }
  },
  template: `
  <div class="checkbox" :class="['checkbox--'+modifier]">
    <div class="checkbox__wrapper">
      <label class="checkbox__label" tabindex="0" :class="[isChecked?'is-active':'', !isValid ? 'is-error': '']">
        <div class="checkbox__icon">
          <input
            class="checkbox__icon-el"
            type="checkbox"
            :name="name"
            :value="value"
            :checked="isChecked"
            @change="onChange" />
              <svg class="checkbox__icon-tick"  width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="9.5" fill="#3A627C" stroke="#3A627C"/><path d="M6 10.249l2.542 2.542L14 7.333" stroke="#fff" stroke-width="1.5"/></svg>
            <svg class="checkbox__icon-loading" viewBox="0 0 456.817 456.817">
              <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-loading" x="0" y="0"></use>
            </svg>
          </div>
          <span v-html="label" class="p1"></span>
      </label>
    </div>
  </div>
  `
})
